<template>
  <v-list nav dense>
    <template>
      <v-list-item link router to="/home" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('inicio') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group prepend-icon="mdi-shield-account" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Marshall</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/golf/marshall/outings" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-clock-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Salidas del Día
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/marshall/starter-order" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-golf-tee</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Orden de Salida
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/marshall/warnings" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-alert-octagon</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Amonestaciones
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item link router to="/settings" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-cog-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('configuracion') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link router to="/ayuda" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('Ayuda') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'marshall'
}
</script>

<style scoped>
.list:hover {
  background: white;
  opacity: 0.85;
}
</style>
